/* eslint-disable typescript-sort-keys/string-enum */

/**
 * These should be ordered in the order they appear in the UI.
 */
enum ListingStep {
  Setup = "Setup",
  AddUnlockable = "AddUnlockable",
  CreatePnft = "CreatePnft",
}

export default ListingStep;
